<!-- Assurance Scolaire -->
<div
  *ngIf="isSchoolInsuranceSelected"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full p-1 pt-12">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "optionsList.schoolOption" | translate }}
    </span>
  </div>
  <div class="flex justify-end items-center w-full sm:w-1/3 p-1 ml-0 sm:ml-auto">
    <button
      pButton
      type="button"
      label="+ Ajouter un enfant"
      class="bg-primary text-white w-full p-1 font-app-light text-sm"
      [disabled]="preventOptionSubscription || childrenInformations.length > 5"
      (click)="addChild()"></button>
  </div>
</div>
<ng-container *ngFor="let item of childrenInformations; let first = first; let i = index">
  <div
    *ngIf="isSchoolInsuranceSelected"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full p-1 pt-8">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <p-button
        class="p-1"
        (onClick)="onChildRemove(i)"
        [disabled]="preventOptionSubscription">
        <span
          class="pi pi-trash"
          style="color: red"></span>
      </p-button>
      <span class="font-app-regular font-bold text-dark text-sm md:text-base">
        {{ i + 1 }}{{ (first ? "scholarInsurance.firstChildName" : "scholarInsurance.nthChildName") | translate }}
      </span>
    </div>
  </div>
  <div *ngFor="let value of item.values">
    <div
      *ngIf="isSchoolInsuranceSelected && value.code === ForOptTarif.PRENOM_ENFANT"
      class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "scholarInsurance.firstName" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <input
            [(ngModel)]="value.value"
            pInputText
            [disabled]="
              !getIsEditable(
                policyFieldsVM,
                PolicyFields.FOROPTTARIF,
                ForOptTarif.PRENOM_ENFANT,
                hasEndorsementWait4Sign
              )
            "
            type="text"
            [ngClass]="
              getInputClass(
                childFirstNameHasChanged[i],
                getIsEditable(
                  policyFieldsVM,
                  PolicyFields.FOROPTTARIF,
                  ForOptTarif.PRENOM_ENFANT,
                  hasEndorsementWait4Sign
                )
              ) + ' w-full'
            "
            (ngModelChange)="onChildFirstNameChange(i)"
            [placeholder]="'scholarInsurance.firstNamePlaceholder' | translate" />
        </div>
      </div>
    </div>
    <div
      *ngIf="isSchoolInsuranceSelected && value.code === ForOptTarif.NOM_ENFANT"
      class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "scholarInsurance.lastName" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <input
            [(ngModel)]="value.value"
            pInputText
            [disabled]="
              !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.NOM_ENFANT, hasEndorsementWait4Sign)
            "
            type="text"
            [ngClass]="
              getInputClass(
                childLastNameHasChanged[i],
                getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.NOM_ENFANT, hasEndorsementWait4Sign)
              ) + ' w-full'
            "
            (ngModelChange)="onChildLastNameChange(i)"
            [placeholder]="'scholarInsurance.lastNamePlaceholder' | translate" />
        </div>
      </div>
    </div>
    <div
      *ngIf="isSchoolInsuranceSelected && value.code === ForOptTarif.DATE_ENFANT"
      class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "scholarInsurance.birthDate" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <p-calendar
            [(ngModel)]="value.value"
            [placeholder]="'scholarInsurance.birthDatePlaceholder' | translate"
            inputId="dateDeNaissance"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [disabled]="
              !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.DATE_ENFANT, hasEndorsementWait4Sign)
            "
            appendTo="body"
            [ngClass]="
              getCalendarClass(
                childBirthDateHasChanged[i],
                getIsEditable(
                  policyFieldsVM,
                  PolicyFields.FOROPTTARIF,
                  ForOptTarif.DATE_ENFANT,
                  hasEndorsementWait4Sign
                )
              ) + ' w-full'
            "
            [minDate]="minTerminationDate"
            [maxDate]="maxTerminationDate"
            (ngModelChange)="onChildBirthDateChange(i)"
            styleClass="w-full">
          </p-calendar>
        </div>
      </div>
    </div>
  </div>
</ng-container>
